var echarts = require('echarts/lib/echarts');

require('./liquidFillSeries');
require('./liquidFillView');


echarts.registerVisual(
    echarts.util.curry(
        require('echarts/lib/visual/dataColor'), 'liquidFill'
    )
);



//////////////////
// WEBPACK FOOTER
// ./src/liquidFill.js
// module id = 74
// module chunks = 0